import { action, computed, makeObservable } from 'mobx'
import Checklist, { NotesSupportingItemInput } from '../../../../Checklist'
import { getFeatureToggleClient } from '../../../../../infra/featureToggles'
import Job from '../../../../Job'
import InfoGatheringStore from '../../../../InfoGatheringStore'
import NotesDialogViewModel from './NotesDialog/NotesDialogViewModel'
import { AlertFactory } from '../../../../../alerts/Alert'
import { IsFirmAdminInWorkspace } from '../../JobRootViewModel'

export default class NotesViewModel {
  notesDialogVM = new NotesDialogViewModel(this, this.newAlert)

  public constructor(
    public job: Job,
    public infoGatheringStore: InfoGatheringStore,
    private getChecklist: () => Checklist | undefined,
    private isFirmAdminInWorkspace: IsFirmAdminInWorkspace,
    private newAlert: AlertFactory,
  ) {
    makeObservable(this)
  }

  @computed
  get isFirmAdmin() {
    return this.isFirmAdminInWorkspace(this.job.workspace.id)
  }

  /**
   * Determine that we are gathering that info for the job.
   */
  @computed
  get isInfoGatheringStep() {
    return this.job.status === 'INFO_GATHERING'
  }

  @computed
  get canEditNotes() {
    return this.isFirmAdmin && this.isInfoGatheringStep
  }

  @computed
  get checklist() {
    return this.getChecklist()
  }

  @computed
  get notesSection() {
    return this.checklist?.notesSection
  }

  @computed
  get notesSupportingItem() {
    return this.notesSection?.notesSupportingItem
  }

  @computed
  get notesSupportingItemInput() {
    return this.notesSupportingItem?.input as NotesSupportingItemInput
  }

  @computed
  get areNotesEnabled() {
    return Boolean(
      getFeatureToggleClient().variation('Portals.NotesSupporting', false) &&
        !!this.notesSupportingItem,
    )
  }

  @computed
  get disableChatForFirmAdmin() {
    return this.isFirmAdmin && this.areNotesEnabled
  }

  @action.bound
  showNotesDialog() {
    this.notesDialogVM.show()
  }
}
